import * as types from '../../actionTypes'

export const fetchingTrainingStatusesCss = () => {
  return {
    type: types.FETCHING_LMS_TRAINING_STATUSES_CSS,
  }
}

export const fetchingTrainingStatusesErrorCss = (
  error = 'There was a problem loading this users training status. Please try again later',
) => {
  return {
    type: types.FETCHING_LMS_TRAINING_STATUSES_ERROR_CSS,
    error,
  }
}

export const fetchingTrainingStatusesSuccessCss = status => {
  return {
    type: types.FETCHING_LMS_TRAINING_STATUSES_SUCCESS_CSS,
    status,
  }
}

export const fetchingChildModuleStatus = () => {
  return {
    type: types.FETCHING_LMS_CHILD_MODULE_STATUSES,
  }
}

export const fetchingChildModuleStatusSuccess = (moduleFilter, program) => {
  return {
    type: types.FETCHING_LMS_CHILD_MODULE_STATUSES_SUCCESS,
    moduleFilter,
    program,
  }
}

export const fetchingChildModuleStatusError = (
  error = 'There was a problem fetching the child module paths for this user. Please try again later',
) => {
  return {
    type: types.FETCHING_LMS_CHILD_MODULE_STATUSES_ERROR,
    error,
  }
}

// TODO: Move with the rest of Update Training Path Status
export const updateTrainingPathStatus = () => {
  return {
    type: types.UPDATING_LMS_TRAINING_PATH,
  }
}

export const addTrainingPathStatusError = (
  error = 'There was a problem adding training to this user. Please try again later',
) => {
  return {
    type: types.ADD_LMS_TRAINING_PATH_ERROR,
    error,
  }
}

export const addTrainingPathStatusSuccess = status => {
  return {
    type: types.ADD_LMS_TRAINING_PATH_SUCCESS,
    status,
  }
}

export const addTrainingPathStatus = () => {
  return {
    type: types.ADD_LMS_TRAINING_PATH,
  }
}

export const updateTrainingPathStatusError = (
  error = 'There was a problem loading this users training status. Please try again later',
) => {
  return {
    type: types.UPDATING_LMS_TRAINING_PATH_ERROR,
    error,
  }
}

export const updateTrainingPathStatusSuccess = status => {
  return {
    type: types.UPDATING_LMS_TRAINING_PATH_SUCCESS,
    status,
  }
}

export const setActiveSkuCode = skuCode => ({
  type: types.SET_ACTIVE_SKU_CODE,
  skuCode,
})

export const savingTraining = saving => ({
  type: types.IS_SAVING_TRAINING,
  saving,
})

export const clearChildModuleStatus = program => ({
  type: types.CLEAR_LMS_CHILD_MODULE_STATUSES,
  program,
})
